<template>
    <h1 class="custom-h1" block v-if="activeChar" style="height: 80px; padding: 0;">
        <v-container style="padding: 0;">
            <v-row class="centered-content" style="padding: 0;">
                <v-col cols="7" style="padding: 0; margin-bottom: 15px;">
                    {{ Name }}
                </v-col>
                <v-col cols="1" v-if="user">
                    <v-tooltip text="Speichern" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-img :src="require('@/assets/OIcon/SpeichernIcon.png')" alt="Speichern" height="45"
                                class="icon-img" v-bind="props" @click="saveChar" v-show="this.Bearbeitungsmodus" />
                        </template>
                    </v-tooltip>
                </v-col>
                <v-col cols="1" v-if="user">
                    <v-tooltip text="zum Löschen ALT gedrückt halten" location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-img :src="require('@/assets/OIcon/LöschenIcon.png')" alt="Löschen" height="45"
                                class="icon-img" v-bind="props" @click.alt="deleteChar"
                                v-show="this.Bearbeitungsmodus" />
                        </template>
                    </v-tooltip>
                </v-col>
                <v-col cols="3">
                    <v-switch label="Bearbeitungsmodus" color=green v-model="Bearbeitungsmodus" v-show="!this.ro" />
                </v-col>
            </v-row>
        </v-container>
    </h1>

    <div class="custom-sitebuttons">
        <v-container>
            <v-row>
                <v-col>
                    <v-btn @click="this.site = 1" class="custom-pointer"
                        :style="this.site == 1 ? 'background-color: rgba(0,50,0,0.5)' : 'background-color: rgba(50,50,50,0.5)'">1</v-btn>
                </v-col>
                <v-col>
                    <v-btn @click="this.site = 2" class="custom-pointer"
                        :style="this.site == 2 ? 'background-color: rgba(0,50,0,0.5)' : 'background-color: rgba(50,50,50,0.5)'">2</v-btn>
                </v-col>
                <v-col>
                    <v-btn @click="this.site = 3" class="custom-pointer"
                        :style="this.site == 3 ? 'background-color: rgba(0,50,0,0.5)' : 'background-color: rgba(50,50,50,0.5)'">3</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>

    <!-- SEITE 1 -->
    <v-container v-show="this.site == 1">
        <v-row v-show="this.Bearbeitungsmodus">
            <v-col cols="6">
                <v-text-field label="Name" v-model="Name"></v-text-field>
            </v-col>
            <v-col cols="4">
                <v-file-input label="Charakter Bild hochladen" v-model="fileHandle" ref="fileInput"></v-file-input>
            </v-col>
            <v-col cols="2">
                <v-btn @click="fileHandler('Bild')" style="margin-bottom: 15px;">Upload</v-btn>
            </v-col>
        </v-row>
        <v-row v-show="this.Bearbeitungsmodus">
            <v-col cols="6">
                <v-text-field label="Charakterspezifischer Webhook" v-model="csWebhook"></v-text-field>
            </v-col>
        </v-row>
        <v-row v-show="this.Bearbeitungsmodus">
            <v-col cols="4">
                <v-text-field label="Freigabe User-ID" v-model="neueFreigabe"></v-text-field>
            </v-col>
            <v-col cols="1">
                <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" @click="addoUser()">➕</v-btn>
                    </template>
                    <span>
                        Fügt eine Leseberechtigung zu diesem Charakter für die eingegebene User-ID hinzu.<br>
                        Die User-ID kann vom zu berechtigenden User in deren Einstellungen ausgelesen werden.
                    </span>
                </v-tooltip>
            </v-col>
            <v-col cols="1">
                <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" @click="deleteoUsers()">🧹</v-btn>
                    </template>
                    <span>
                        Löscht alle Leseberechtigung zu diesem Charakter.
                    </span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="10"></v-col>
            <v-col cols="2">
                <v-img :src='charPicurl' style="margin-bottom: -999px; margin-top: -25px; margin-right: -80px;" once
                    max-height="145px" max-width="250px"></v-img>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-container
                    style="border: 1px solid #555; border-radius: 8px; padding: 15px; padding-bottom: 25px; padding-right: 20px;">
                    <v-row>
                        <v-col cols="10" v-show=Bearbeitungsmodus>
                            <v-text-field label="Magieattribute" v-model="this.Magieattribute" :disabled="false"
                                type="Text"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10" v-show=Bearbeitungsmodus>
                                    <v-text-field label="Leben" v-model="this.Leben" :disabled="true"
                                        type="Number"></v-text-field>
                                </v-col>
                                <v-col cols="10" v-show=!Bearbeitungsmodus>
                                    <v-text-field label="Leben (max.)" v-model="this.LebenMax" :disabled="true"
                                        type="Number"></v-text-field>
                                </v-col>
                                <v-col cols="2" v-show=Bearbeitungsmodus>
                                    <v-btn
                                        :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Leben ? 'green' : 'gray' }"
                                        @click="steigern('Leben', $event)">+</v-btn>
                                </v-col>
                            </v-row>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10">
                                    <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Nahkampf') }">
                                        <v-text-field label="Nahkampf" v-model="this.Nahkampf" :disabled="true"
                                            type="Number"></v-text-field>
                                    </div>
                                </v-col>
                                <v-col cols="2" v-show=!Bearbeitungsmodus>
                                    <v-btn
                                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                        @click="roll('Nahkampf')">🎲</v-btn>
                                </v-col>
                                <v-col cols="2" v-show=Bearbeitungsmodus>
                                    <v-btn
                                        :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Nahkampf ? 'green' : 'gray' }"
                                        @click="steigern('Nahkampf', $event)">+</v-btn>
                                </v-col>
                            </v-row>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10">
                                    <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Ausweichen') }">
                                        <v-text-field label="Ausweichen" v-model="this.Ausweichen" :disabled="true"
                                            type="Number"></v-text-field>
                                    </div>
                                </v-col>
                                <v-col cols="2" v-show=!Bearbeitungsmodus>
                                    <v-btn
                                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                        @click="roll('Ausweichen')">🎲</v-btn>
                                </v-col>
                                <v-col cols="2" v-show=Bearbeitungsmodus>
                                    <v-btn
                                        :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Ausweichen ? 'green' : 'gray' }"
                                        @click="steigern('Ausweichen', $event)">+</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10">
                                    <v-text-field label="Mana" v-model="this.Mana" :disabled="true"
                                        type="Number"></v-text-field>
                                </v-col>
                                <v-col cols="2" v-show=Bearbeitungsmodus>
                                    <v-btn
                                        :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Mana ? 'green' : 'gray' }"
                                        @click="steigern('Mana', $event)">+</v-btn>
                                </v-col>
                            </v-row>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10">
                                    <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Fernkampf') }">
                                        <v-text-field label="Fernkampf" v-model="this.Fernkampf" :disabled="true"
                                            type="Number"></v-text-field>
                                    </div>

                                </v-col>
                                <v-col cols="2" v-show=!Bearbeitungsmodus>
                                    <v-btn
                                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                        @click="roll('Fernkampf')">🎲</v-btn>
                                </v-col>
                                <v-col cols="2" v-show=Bearbeitungsmodus>
                                    <v-btn
                                        :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Fernkampf ? 'green' : 'gray' }"
                                        @click="steigern('Fernkampf', $event)">+</v-btn>
                                </v-col>
                            </v-row>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10">
                                    <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Abwehren') }">
                                        <v-text-field label="Abwehren" v-model="this.Abwehren" :disabled="true"
                                            type="Number"></v-text-field>
                                    </div>
                                </v-col>
                                <v-col cols="2" v-show=!Bearbeitungsmodus>
                                    <v-btn
                                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                        @click="roll('Abwehren')">🎲</v-btn>
                                </v-col>
                                <v-col cols="2" v-show=Bearbeitungsmodus>
                                    <v-btn
                                        :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Abwehren ? 'green' : 'gray' }"
                                        @click="steigern('Abwehren', $event)">+</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10">
                                    <v-text-field label="Erfahrungspunkte (Aktuell)" v-model="this.EPAktuell"
                                        :disabled="!this.Bearbeitungsmodus" type="Number"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10">
                                    <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Initiative') }">
                                        <v-text-field label="Initiative" v-model="this.Initiative" :disabled="true"
                                            type="Number"></v-text-field>
                                    </div>
                                </v-col>
                                <v-col cols="2" v-show=!Bearbeitungsmodus>
                                    <v-btn
                                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                        @click="roll('Initiative')">🎲</v-btn>
                                </v-col>
                                <v-col cols="2" v-show=Bearbeitungsmodus>
                                    <v-btn
                                        :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Initiative ? 'green' : 'gray' }"
                                        @click="steigern('Initiative', $event)">+</v-btn>
                                </v-col>
                            </v-row>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10">
                                    <div
                                        :class="{ 'left-stripe-wrapper': Magieattribute.includes('Magieverteidigung') }">
                                        <v-text-field label="Magieverteidigung" v-model="this.Magieverteidigung"
                                            :disabled="true" type="Number"></v-text-field>
                                    </div>
                                </v-col>
                                <v-col cols="2" v-show=!Bearbeitungsmodus>
                                    <v-btn
                                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                        @click="roll('Magieverteidigung')">🎲</v-btn>
                                </v-col>
                                <v-col cols="2" v-show=Bearbeitungsmodus>
                                    <v-btn
                                        :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Magieverteidigung ? 'green' : 'gray' }"
                                        @click="steigern('Magieverteidigung', $event)">+</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10">
                                    <v-text-field label="Erfahrungspunkte (Gesamt)" v-model="this.EPGesamt"
                                        v-show=Bearbeitungsmodus :disabled="true" type="Number"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row style="margin-bottom: 120px;">
                                <v-col cols="10">
                                    <v-text-field label="Erfahrungspunkte (für Sonderfertigkeiten)"
                                        v-model="this.EPSonderfertigkeiten" v-show=Bearbeitungsmodus :disabled="true"
                                        type="Number"></v-text-field>
                                </v-col>
                                <v-col cols="2" v-show=Bearbeitungsmodus>
                                    <v-btn
                                        :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > 0 ? 'green' : 'gray' }"
                                        @click="steigern('Sonderfertigkeit', $event)">+</v-btn>
                                </v-col>
                            </v-row>
                            <v-row style="margin-bottom: -170px;" v-show=Bearbeitungsmodus>
                            </v-row>
                            <v-row style="margin-bottom: -50px;">
                                <v-col cols="10">
                                    <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Willenskraft') }">
                                        <v-text-field label="Willenskraft" v-model="this.Willenskraft" :disabled="true"
                                            type="Number"></v-text-field>
                                    </div>
                                </v-col>
                                <v-col cols="2" v-show=!Bearbeitungsmodus>
                                    <v-btn
                                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                        @click="roll('Willenskraft')">🎲</v-btn>
                                </v-col>
                                <v-col cols="2" v-show=Bearbeitungsmodus>
                                    <v-btn
                                        :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Willenskraft ? 'green' : 'gray' }"
                                        @click="steigern('Willenskraft', $event)">+</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-container
                    style="border: 1px solid #555; border-radius: 8px; padding: 15px; padding-bottom: 25px; padding-right: 20px;">
                    <v-row justify="center">
                        <p style="color: grey;">Körper & Bewegung</p>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Kraftakt') }">
                                <v-text-field label="Kraftakt" v-model="this.Kraftakt" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px; font-size: larger; background-color: transparent;"
                                @click="roll('Kraftakt')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Kraftakt ? 'green' : 'gray' }"
                                @click="steigern('Kraftakt', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Geschicklichkeit') }">
                                <v-text-field label="Geschicklichkeit" v-model="this.Geschicklichkeit" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px; font-size: larger; background-color: transparent;"
                                @click="roll('Geschicklichkeit')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Geschicklichkeit ? 'green' : 'gray' }"
                                @click="steigern('Geschicklichkeit', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Heimlichkeit') }">
                                <v-text-field label="Heimlichkeit" v-model="this.Heimlichkeit" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Heimlichkeit')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Heimlichkeit ? 'green' : 'gray' }"
                                @click="steigern('Heimlichkeit', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Fingerfertigkeit') }">
                                <v-text-field label="Fingerfertigkeit" v-model="this.Fingerfertigkeit" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Fingerfertigkeit')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Fingerfertigkeit ? 'green' : 'gray' }"
                                @click="steigern('Fingerfertigkeit', $event)">+</v-btn>
                        </v-col>
                    </v-row>

                </v-container>
            </v-col>

            <v-col>
                <v-container
                    style="border: 1px solid #555; border-radius: 8px; padding: 15px; padding-bottom: 25px; padding-right: 20px;">
                    <v-row justify="center">
                        <p style="color: grey;">Wahrnehmung & Umwelt</p>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Sinnesschärfe') }">
                                <v-text-field label="Sinnesschärfe" v-model="this.Sinnesschärfe" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Sinnesschärfe')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Sinnesschärfe ? 'green' : 'gray' }"
                                @click="steigern('Sinnesschärfe', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Nachforschung') }">
                                <v-text-field label="Nachforschung" v-model="this.Nachforschung" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Nachforschung')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Nachforschung ? 'green' : 'gray' }"
                                @click="steigern('Nachforschung', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Überlebenskunst') }">
                                <v-text-field label="Überlebenskunst" v-model="this.Überlebenskunst" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Überlebenskunst')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Überlebenskunst ? 'green' : 'gray' }"
                                @click="steigern('Überlebenskunst', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Handwerk') }">
                                <v-text-field label="Handwerk" v-model="this.Handwerk" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Handwerk')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Handwerk ? 'green' : 'gray' }"
                                @click="steigern('Handwerk', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>

            <v-col>
                <v-container
                    style="border: 1px solid #555; border-radius: 8px; padding: 15px; padding-bottom: 25px; padding-right: 20px;">
                    <v-row justify="center">
                        <p style="color: grey;">Wissen & Magie</p>
                    </v-row>

                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Heilkunde') }">
                                <v-text-field label="Heilkunde" v-model="this.Heilkunde" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Heilkunde')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Heilkunde ? 'green' : 'gray' }"
                                @click="steigern('Heilkunde', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Magie') }">
                                <v-text-field label="Magie" v-model="this.Magie" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Magie')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Magie ? 'green' : 'gray' }"
                                @click="steigern('Magie', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Wissen') }">
                                <v-text-field label="Wissen" v-model="this.Wissen" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Wissen')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Wissen ? 'green' : 'gray' }"
                                @click="steigern('Wissen', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Kosmologie') }">
                                <v-text-field label="Kosmologie" v-model="this.Kosmologie" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Kosmologie')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Kosmologie ? 'green' : 'gray' }"
                                @click="steigern('Kosmologie', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
            <v-col>
                <v-container
                    style="border: 1px solid #555; border-radius: 8px; padding: 15px; padding-bottom: 25px; padding-right: 20px;">
                    <v-row justify="center">
                        <p style="color: grey;">Sozial & Interaktion</p>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Beeinflussen') }">
                                <v-text-field label="Beeinflussen" v-model="this.Beeinflussen" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Beeinflussen')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Beeinflussen ? 'green' : 'gray' }"
                                @click="steigern('Beeinflussen', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Einschätzen') }">
                                <v-text-field label="Einschätzen" v-model="this.Einschätzen" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Einschätzen')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Einschätzen ? 'green' : 'gray' }"
                                @click="steigern('Einschätzen', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Handeln') }">
                                <v-text-field label="Handeln" v-model="this.Handeln" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Handeln')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Handeln ? 'green' : 'gray' }"
                                @click="steigern('Handeln', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                    <v-row style="margin-bottom: -50px;">
                        <v-col cols="10">
                            <div :class="{ 'left-stripe-wrapper': Magieattribute.includes('Täuschen') }">
                                <v-text-field label="Täuschen" v-model="this.Täuschen" :disabled="true"
                                    type="Number"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="2" v-show=!Bearbeitungsmodus>
                            <v-btn
                                style="padding: 0 6px; min-width: 0px;  margin-top: 12px;font-size: larger; background-color: transparent;"
                                @click="roll('Täuschen')">🎲</v-btn>
                        </v-col>
                        <v-col cols="2" v-show=Bearbeitungsmodus>
                            <v-btn
                                :style="{ padding: '0 6px', minWidth: '0px', marginTop: '12px', fontSize: 'larger', backgroundColor: EPAktuell > Täuschen ? 'green' : 'gray' }"
                                @click="steigern('Täuschen', $event)">+</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3">
                <v-container style="border: 1px solid #555; border-radius: 8px; 
                        padding: 15px; margin-top: 5px;
                        padding-bottom: 25px; padding-right: 20px;">
                    <v-text-field box label="Wurf" v-model="this.WurfBeschreibung"></v-text-field>
                    <v-text-field label="w20 (Anzahl)" v-model="this.w20" type="number" />
                    <v-text-field label="w6 (Anzahl)" v-model="this.w6" type="number" />
                    <v-text-field label="+Bonus" v-model="this.wbonus" type="number" />

                    <v-btn color="success" :disabled="+this.w6 <= 0 && +this.w20 <= 0"
                        style="margin-top: 0px; margin-left: 15px; margin-bottom: 0px;"
                        @click="rollrest">Würfeln</v-btn>

                    <v-btn color="success" :disabled="+this.w6 <= 0 && +this.w20 <= 0"
                        style="margin-top: 0px; margin-left: 15px; margin-bottom: 0px;" @click="clear">Clear</v-btn>

                    <v-btn style="padding: 0 6px; min-width: 0px;  margin-top: 12px;text-transform: none; "
                        @click="rollschaden('leicht')">🎲 w6-2 🎲</v-btn>
                    <v-btn
                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px; margin-left: 6px; text-transform: none; "
                        @click="rollschaden('mittel')">🎲 w6 🎲</v-btn>
                    <v-btn
                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px; margin-left: 6px; text-transform: none; "
                        @click="rollschaden('schwer')">🎲 w6+2 🎲</v-btn>
                    <v-btn
                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px; margin-left: 6px; text-transform: none; "
                        @click="rollschaden('sehr schwer')">🎲 w6+4 🎲</v-btn>
                    <v-btn
                        style="padding: 0 6px; min-width: 0px;  margin-top: 12px; margin-left: 6px; text-transform: none; "
                        @click="rollschaden('kritisch')">🎲 2w6+4 🎲</v-btn>
                </v-container>
            </v-col>
            <v-col cols="9">
                <v-container style="border: 1px solid #555; border-radius: 8px; 
                        padding: 15px; margin-top: 5px;
                        padding-bottom: 25px; padding-right: 20px;">
                    <v-textarea label="Pfad des Lichts" v-model="KlasseOffen" auto-grow rows="2"
                        :disabled="!this.Bearbeitungsmodus" />
                    <v-textarea label="Stimme im Nebel" v-model="KlasseVersteckt" auto-grow rows="2"
                        :disabled="!this.Bearbeitungsmodus" />
                    <v-textarea label="Schatten der Seele" v-model="KlasseVerdeckt" auto-grow rows="2"
                        style="margin-bottom: -25px;" :disabled="!this.Bearbeitungsmodus" />
                </v-container>
            </v-col>
        </v-row>
    </v-container>

    <!-- SEITE 2 -->
    <v-container v-show="this.site == 2">
        <h2 class="custom-h2" block>Notizen</h2>
        <v-row>
            <v-col cols="12">
                <v-btn @click="saveNotizen" :disabled="ro">speichern</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-textarea label="Notiz" v-model="Notizen" auto-grow rows="1" :disabled="ro" />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="8">
                <v-textarea label="Notiz" v-model="Notizen1" auto-grow :disabled="ro" />
            </v-col>
            <v-col cols="3">
                <v-textarea label="Notiz" v-model="Notizen2" auto-grow :disabled="ro" />
            </v-col>
            <v-col cols="1">
                <v-textarea label="Notiz" v-model="Notizen3" auto-grow :disabled="ro" />
            </v-col>
        </v-row>
    </v-container>

    <!-- SEITE 3 -->
    <v-container v-show="this.site == 3"
        style="border: 1px solid #555; border-radius: 8px; padding: 15px; padding-bottom: 25px; padding-right: 20px; margin: 0px;">
        <h2 class="custom-h2" block>Charakterbogen</h2>
        <v-row v-show="this.Bearbeitungsmodus || !this.charPDFurl">
            <v-col>
                <v-file-input label="Charakterbogen hochladen" v-model="fileHandle" ref="fileInput"
                    :disabled="ro"></v-file-input>
            </v-col>
            <v-col>
                <v-btn @click="fileHandler('Char')" style="margin-bottom: 15px;" :disabled="ro">Upload</v-btn>
            </v-col>
        </v-row>
        <iframe v-if="charPDFurl" :src="charPDFurl" width="100%" height="1200px"></iframe>
    </v-container>

</template>

<script>
import logger from '@/utils/logger.js'
import characterMixin from '@/mixins/characterMixin.js'
import { db } from '@/firebase.js'
import { doc, updateDoc } from 'firebase/firestore';
import { sendMessageToDisc } from '../composables/useDiscord.js'
import { sendMessageToHistory } from '../composables/useSendHistory.js'

export default {
    mixins: [characterMixin],
    data() {
        return {
            site: 1,
            Bearbeitungsmodus: false,

            Magieattribute: 'Ausweichen',

            KlasseOffen: '',
            KlasseVersteckt: '',
            KlasseVerdeckt: '',

            WurfBeschreibung: '',

            Leben: 0,
            LebenMax: 20,
            Mana: 5,
            EPAktuell: 0,
            EPGesamt: 0,
            EPSonderfertigkeiten: 0,

            Nahkampf: 0,
            Fernkampf: 0,
            Initiative: 0,

            Ausweichen: 0,
            Abwehren: 0,
            Magieverteidigung: 0,
            Willenskraft: 0,

            Kraftakt: 0,
            Geschicklichkeit: 0,
            Heimlichkeit: 0,
            Fingerfertigkeit: 0,

            Sinnesschärfe: 0,
            Nachforschung: 0,
            Überlebenskunst: 0,
            Handwerk: 0,

            Heilkunde: 0,
            Magie: 0,
            Wissen: 0,
            Kosmologie: 0,

            Beeinflussen: 0,
            Täuschen: 0,
            Einschätzen: 0,
            Handeln: 0,

            w6: 0,
            w20: 0,
            wbonus: 0,

        };
    },

    methods: {

        applyCharData(data) {
            this.KlasseOffen = data.KlasseOffen
            this.KlasseVersteckt = data.KlasseVersteckt
            this.KlasseVerdeckt = data.KlasseVerdeckt

            this.Leben = data.Leben
            this.LebenMax = 20 + +this.Leben
            this.Mana = data.Mana
            this.EPAktuell = data.EPAktuell
            this.EPGesamt = data.EPGesamt
            this.EPSonderfertigkeiten = data.EPSonderfertigkeiten
            this.Magieattribute = data.Magieattribute

            this.Nahkampf = data.Nahkampf
            this.Fernkampf = data.Fernkampf
            this.Initiative = data.Initiative

            this.Ausweichen = data.Ausweichen
            this.Abwehren = data.Abwehren
            this.Magieverteidigung = data.Magieverteidigung
            this.Willenskraft = data.Willenskraft

            this.Kraftakt = data.Kraftakt
            this.Geschicklichkeit = data.Geschicklichkeit
            this.Heimlichkeit = data.Heimlichkeit
            this.Fingerfertigkeit = data.Fingerfertigkeit

            this.Sinnesschärfe = data.Sinnesschärfe
            this.Nachforschung = data.Nachforschung
            this.Überlebenskunst = data.Überlebenskunst
            this.Handwerk = data.Handwerk

            this.Heilkunde = data.Heilkunde
            this.Magie = data.Magie
            this.Wissen = data.Wissen
            this.Kosmologie = data.Kosmologie

            this.Beeinflussen = data.Beeinflussen
            this.Täuschen = data.Täuschen
            this.Einschätzen = data.Einschätzen
            this.Handeln = data.Handeln

            this.calcEP()
        },

        saveChar() {
            if (!this.$store.state.activeCharID) {
                console.error("Keine activeCharID verfügbar.")
                return
            }
            try {
                const docRef = doc(db, "Charaktere", this.$store.state.activeCharID);
                updateDoc(docRef, {
                    Name: this.Name,
                    csWebhook: this.csWebhook,

                    KlasseOffen: this.KlasseOffen,
                    KlasseVersteckt: this.KlasseVersteckt,
                    KlasseVerdeckt: this.KlasseVerdeckt,
                    Leben: this.Leben,
                    Mana: this.Mana,
                    EPAktuell: this.EPAktuell,
                    EPGesamt: this.EPGesamt,
                    EPSonderfertigkeiten: this.EPSonderfertigkeiten,
                    Magieattribute: this.Magieattribute,
                    Nahkampf: this.Nahkampf,
                    Fernkampf: this.Fernkampf,
                    Initiative: this.Initiative,
                    Ausweichen: this.Ausweichen,
                    Abwehren: this.Abwehren,
                    Magieverteidigung: this.Magieverteidigung,
                    Willenskraft: this.Willenskraft,
                    Kraftakt: this.Kraftakt,
                    Geschicklichkeit: this.Geschicklichkeit,
                    Heimlichkeit: this.Heimlichkeit,
                    Fingerfertigkeit: this.Fingerfertigkeit,
                    Sinnesschärfe: this.Sinnesschärfe,
                    Nachforschung: this.Nachforschung,
                    Überlebenskunst: this.Überlebenskunst,
                    Handwerk: this.Handwerk,
                    Heilkunde: this.Heilkunde,
                    Magie: this.Magie,
                    Wissen: this.Wissen,
                    Kosmologie: this.Kosmologie,
                    Beeinflussen: this.Beeinflussen,
                    Täuschen: this.Täuschen,
                    Einschätzen: this.Einschätzen,
                    Handeln: this.Handeln
                })
                this.$store.commit('callSnackbar', this.Name + " wurde gespeichert.")
            }
            catch (err) {
                console.error("Fehler beim Speichern des Dokuments: ", err)
            }
        },

        sumTo(n) {
            var tn = parseInt(n)
            if (typeof tn !== 'number' || tn < 0 || !Number.isInteger(tn)) {
                logger.log("SumTo konnte nicht ausgeführt werden.")
                return 0
            }
            else {
                return tn * (tn + 1) / 2
            }
        },

        calcEP() {
            var total = 0
            total += parseInt(this.EPSonderfertigkeiten)

            total += this.sumTo(this.Leben)
            total += this.sumTo(this.Mana)

            total += this.sumTo(this.Nahkampf)
            total += this.sumTo(this.Fernkampf)
            total += this.sumTo(this.Initiative)

            total += this.sumTo(this.Ausweichen)
            total += this.sumTo(this.Abwehren)
            total += this.sumTo(this.Magieverteidigung)
            total += this.sumTo(this.Willenskraft)

            total += this.sumTo(this.Kraftakt)
            total += this.sumTo(this.Geschicklichkeit)
            total += this.sumTo(this.Heimlichkeit)
            total += this.sumTo(this.Fingerfertigkeit)

            total += this.sumTo(this.Sinnesschärfe)
            total += this.sumTo(this.Nachforschung)
            total += this.sumTo(this.Überlebenskunst)
            total += this.sumTo(this.Handwerk)

            total += this.sumTo(this.Heilkunde)
            total += this.sumTo(this.Magie)
            total += this.sumTo(this.Wissen)
            total += this.sumTo(this.Kosmologie)

            total += this.sumTo(this.Beeinflussen)
            total += this.sumTo(this.Täuschen)
            total += this.sumTo(this.Einschätzen)
            total += this.sumTo(this.Handeln)

            total += +this.EPAktuell

            this.EPGesamt = total
            logger.log("calcEP Ausgeführt: " + total)

            this.LebenMax = +this.Leben + 20
        },


        steigern(Bezeichnung, event) {
            if (event.ctrlKey) {
                logger.log(Bezeichnung + " rückgängig gemacht");

                if (Bezeichnung == 'Sonderfertigkeit' && this.EPSonderfertigkeiten > 0) {
                    this.EPSonderfertigkeiten--
                    this.EPAktuell++
                    this.calcEP();
                }
                // Rückgängig machen
                else if (this[Bezeichnung] > 0) {
                    this.EPAktuell += this[Bezeichnung];
                    this[Bezeichnung]--;
                    this.calcEP();
                }

            } else {

                if (Bezeichnung == 'Sonderfertigkeit' && this.EPAktuell > 0) {
                    this.EPSonderfertigkeiten++
                    this.EPAktuell--
                    this.calcEP();
                }
                logger.log(Bezeichnung + " gesteigert");
                if (this.EPAktuell > this[Bezeichnung]) {
                    // Steigerung ausführen
                    this[Bezeichnung]++;
                    this.EPAktuell -= this[Bezeichnung];
                    this.calcEP();
                }
            }
        },


        roll(Bezeichnung) {
            logger.log(Bezeichnung, ": ", this[Bezeichnung])
            this.calcEP()

            let result = 'wirft '
            let total = +0

            result += Bezeichnung

            total += +this[Bezeichnung]

            var roll = Math.floor(Math.random() * 20) + 1
            total += +roll

            result += ": w20("
            result += roll
            result += ")"

            if (!+this[Bezeichnung] == 0) {
                result += " + "
                result += this[Bezeichnung]
            }
            result += " = " + total

            if (+roll == 1) {
                result += " \u{1F4A9} \u{1F4A9}"
            }
            if (+roll == 7) {
                result += " \u{1F340} \u{1F340}"
            }
            if (+roll == 13) {
                result += " \u{1F479} \u{1F479}"
            }
            if (+roll == 20) {
                result += " \u{1F929} \u{1F929}"
            }


            sendMessageToDisc(result, this.Name, this.csWebhook)
            sendMessageToHistory(result)
        },

        rollschaden(treffer) {
            this.clear()
            if (treffer == 'leicht') {
                this.WurfBeschreibung = 'Streiftreffer'
                this.w6 = 1
                this.wbonus = -2
            }
            if (treffer == 'mittel') {
                this.WurfBeschreibung = 'Treffer'
                this.w6 = 1
                this.wbonus = 0
            }
            if (treffer == 'schwer') {
                this.WurfBeschreibung = 'Schwerer Treffer'
                this.w6 = 1
                this.wbonus = 2
            }
            if (treffer == 'sehr schwer') {
                this.WurfBeschreibung = 'Sehr schwerer Treffer'
                this.w6 = 1
                this.wbonus = 4
            }
            if (treffer == 'kritisch') {
                this.WurfBeschreibung = 'Kritischer Treffer'
                this.w6 = 2
                this.wbonus = 4
            }
        },

        rollrest() {
            let result = 'wirft '

            if (this.WurfBeschreibung) {
                result += this.WurfBeschreibung + ": "
            }

            let total = 0
            if (+this.w20 > 0) {
                result += this.w20 + "w20 ("
                for (let i = 0; i < this.w20; i++) {
                    var roll = Math.floor(Math.random() * 20) + 1
                    result += roll
                    total += +roll
                    if (+roll == 1) {
                        result += " \u{1F4A9}"
                    }
                    if (+roll == 7) {
                        result += " \u{1F340}"
                    }
                    if (+roll == 13) {
                        result += " \u{1F479}"
                    }
                    if (+roll == 20) {
                        result += " \u{1F929}"
                    }
                    result += ", "
                }
                result = result.slice(0, -2)
                result += ") "
            }
            if (+this.w6 > 0) {
                if (+this.w20 > 0) { result += " + " }
                result += this.w6 + "w6 ("
                for (let i = 0; i < this.w6; i++) {
                    var roll2 = Math.floor(Math.random() * 6) + 1
                    result += roll2 + ", "
                    total += +roll2
                }
                result = result.slice(0, -2)
                result += ")"
            }
            if (this.wbonus) {
                result += " +" + this.wbonus
                total += +this.wbonus
            }
            this.$store.commit('callDicer', { result: result, total: total })
            result += " = " + total
            sendMessageToDisc(result, this.Name, this.csWebhook)
            sendMessageToHistory(result)
        },

        clear() {
            this.WurfBeschreibung = ""
            this.w20 = +0
            this.w6 = +0
            this.wbonus = +0
        },

    }
}
</script>

<style>
.left-stripe-wrapper {
    position: relative;
    padding-left: 16px;
    /* Abstand vom Strich zum Feld */
}

.left-stripe-wrapper::before {
    content: "";
    position: absolute;
    left: 0;
    top: 12px;
    /* Abstand von oben */
    height: 40px;
    /* Länge des Strichs */
    width: 4px;
    background-color: green;
    border-radius: 2px;
}

.button-wuerfel {
    margin-bottom: 12px;
    cursor: pointer;
    height: 32px;
    opacity: 0.6;
    transition: opacity 0.2s ease;
}

.button-wuerfel:hover {
    opacity: 1.0;
    cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}
</style>